import { SalesChannelListPage } from '@/features/sales-channel/pages/SalesChannelListPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/sales-channel/')({
  component: SalesChannelListPage,
})
